// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Description: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M21.43,6.97l-6.72-6.71v0H2.57v23.5h18.85L21.43,6.97L21.43,6.97z M15.75,2.83l3.13,3.1h-3.13V2.83z M20.38,22.71H3.62V1.29
	h11.09v5.15v0.52h5.68V22.71z"/>
<rect x="6.97" y="9.54" width="10.07" height="1.04"/>
<rect x="6.97" y="12.64" width="10.07" height="1.04"/>
<rect x="6.97" y="6.44" width="4.65" height="1.04"/>
<rect x="6.97" y="15.74" width="10.07" height="1.04"/>
<rect x="6.97" y="18.83" width="10.07" height="1.04"/>
</svg>;
};

export default React.memo(Description);
